import { clientApi } from '@phoenix/clientApi';

export default {
  props: {
    model: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },

  computed: {
    downloadName() {
      return 'manual.pdf';
    },
  },

  methods: {
    async downloadFile() {
      const response = await clientApi.get(this.url, { responseType: 'arraybuffer' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.downloadName;
      link.click();
    },
  },
};
